import { Loading } from 'element-ui'
export default {
  data() {
    return {
      // ———————————————————————————————————— 基础 s ————————————————————————————————————
      filterForm: {}, // 筛选数据
      tableData: [], // 表格数据
      selectRow: [], // 表格选中行数据
      editForm: {}, // 表格选中行编辑数据
      areaIdsChecked: [], // 表格选中行编辑地区数据 => 替换筛选地区数据

      centerDialogVisible: false, // 弹框开关
      powerShow: {
        search: false,
        create: false,
        modify: false,
        delete: false,
        import: false,
        export: false,
      }, // 权限显隐
      
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      }, // 页码数据
      // ———————————————————————————————————— 基础 e ————————————————————————————————————
      
      // 根据用户权限，判断用户是否有该功能，没有则隐藏其对应按钮
      showBtn: [
        {isShow: false,id:'search'},
        {isShow: false,id:'modify'},
        {isShow: false,id:'delete'},
        {isShow: false,id:'create'},
        {isShow: false,id:'import'},
        {isShow: false,id:'export'},
      ],
      // 地区数据 - filter
      areaArrs: {
        province: [],
        city: [],
        county: [],
        town: [],
        village: [],
      },
      areaNames: [],
      areaIds: [],
      dis: [],

      lodaingTime: false,
      downShow: false,
    }
  },
  methods: {
    // 分页
    get_page_number(pageNumer) {
      this.pageData.currentPage = pageNumer
      this.filterForm.pageNumber = pageNumer
      this.filterHandler()
    },
    
    pageNumberChange(pageNumer) {
      this.pageData.currentPage = pageNumer
      this.filterHandler()
    },


    //关闭下载模板弹窗
    cutOff(bool) {
      this.downShow = bool
    },
    //导出数据
    Filter_export(api, data) {
      let areaNames = this.areaNames.filter(x => x)
      this.$api.changePlace({areaNames}).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          data.areaId = _R[_R.length-1]
          if (data.areaId) {
            let loadingInstance = Loading.service({
              lock: true,
              text: '导出中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
              fullscreen: true 
            })
            this.$api.getExport(api,data).then(res =>{
              if (res.data.status === 0) {
                this.$nextTick(() => { loadingInstance.dialogClose() }) // 以服务的方式调用的 Loading 需要异步关闭
                this.$api.download_doc(res.data.data)
              } else { this._status(res.data) }
            })
          } else {
            this.$message.warning('请至少输入一个地区')
          }
        }
      })
    },

    // 控制模块的操作按钮是否显示
    isShowBtn(str) {
      if (this.userInfo.admin) { // 是管理员
        this.showBtn.forEach(x => { x.isShow = true })
      } else {
        // 所有按钮显示重置为false
        this.showBtn.forEach(x => { x.isShow = false })
        let privilegesList = this.userInfo.privilegesList
        this.showBtn.forEach(x => {
          if (privilegesList.includes(str + '-' + x.id)) { x.isShow = true }
        })
      }
    },


    // —————————————————————————————————————— 基础 s ——————————————————————————————————————
    // 筛选查询
    filterClick(areaId) {
      this.pageData.currentPage = 1
      this.filterHandler(areaId)
    },
    filterHandler(areaId) {
      areaId ? '' : areaId = this.$refs.areaFilter_filter.findAreaId()
      let rD = {}
      let keys = Object.keys(this.filterForm)
      if (keys.length > 0) {
        keys.forEach(x => {
          if (this.filterForm[x]) {
            rD[x] = this.filterForm[x]
          }
        })
      }
      if (areaId) {
        rD.areaId = areaId
        rD.pageNumber = this.pageData.currentPage
        // console.log(rD)
        this.getData(rD)
      } else { this.$message.warning('请选择地区') }
    },
    
    // 删除
    deleteHandler() {
      let ids = this.selectRow.map(x => x.id)
      let rD = { ids }
      if (this.selectRow.length > 0) {
        this.$confirm('确认删除数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_delete(this.sign, rD).then(res => {
            if (res.data.status === 0 ) {
              this.$message.success('删除成功!')
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 s ——————————————————
              let nowtotal = this.pageData.total - ids.length
              if (nowtotal % this.pageData.pageSize === 0) {
                if (this.pageData.currentPage > 1) {
                  this.pageData.currentPage--
                } else {
                  this.pageData.currentPage = 1
                }
              }
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 e ——————————————————
              console.log('删除后总条数',nowtotal,'当前页数',this.pageData.currentPage)
              this.filterHandler()
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else { this.$message.warning('请至少勾选一条数据') }

    },
    // 打开弹框 修改
    modifyHandler() {
      this.isCreate = false
      this.editForm = JSON.parse(JSON.stringify(this.selectRow[0]))
      delete this.editForm.createTime
      console.log(this.editForm)
      let { provinceId, cityId, countyId, townId, villageId } = this.editForm
      let areaIds = [ provinceId, cityId, countyId, townId, villageId ]
      this.areaIdsChecked = areaIds.filter(x => !!x)
      console.log(areaIds, this.areaIdsChecked)

      this.modifyHandlerCb ? this.modifyHandlerCb() : ''
      this.centerDialogVisible = true
    },
    // 打开弹框 新建
    createHandler() {
      this.isCreate = true
      this.editForm = {}

      if (this.fileList_1) {
        this.fileList_1 = []
        this.fileList_2 = []
        this.fileList_3 = []
      }

      this.centerDialogVisible = true
    },
    // 关闭弹框
    dialogClose() {
      this.centerDialogVisible = false
      // if (this.$refs.uploadImg) {
      //   console.log(this.$refs.uploadImg)
      //   if (this.$refs.uploadImg.length) {
      //     this.$refs.uploadImg.forEach(x => { x.clearFiles() })
      //   } else {
      //     this.$refs.uploadImg.clearFiles()
      //   }
      // }
      if (this.fileList_1) {
        this.fileList_1 = []
        this.fileList_2 = []
        this.fileList_3 = []
      }
      this.editForm = {}
    },
    // 提交弹框
    dialogSubmitCb(mapList, otherParams) {
      let item = this.selectRow[0]
      let rD = {}
      mapList.forEach(x => {
        if (item[x] !== this.editForm[x]) {
          rD[x] = this.editForm[x]
        }
      })
      if (JSON.stringify(rD) !== '{}') {
        rD.id = item.id
        if (otherParams) {
          Object.assign(rD, otherParams)
        }
        console.log(`%cthis.editForm:`, 'color: #f00;', this.editForm, rD)
        this.$api.util_modify(this.sign, rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('成功！')
            this.filterHandler()
            this.dialogClose()
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c没有改变`, 'color: #f0f;')
        this.dialogClose()
      }
    },
    // 获取表格数据
    getDataCb(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.tableData = _R
          this.pageData.total = res.data.size
          console.log(`%c返回数据:`, 'color: #f00;', this.tableData)
        } else { this._status(res.data) }
      })
    },
    // —————————————————————————————————————— 基础 e ——————————————————————————————————————


    init() {//在页面初始渲染的时候，默认查询的数据====根据账号绑定的区域id    后台  服务常调用的方法
      let areaId = this.userInfo.areaId
      this.getData({areaId})
    },


    getAreaidAndData(newForm) {//后台服务页面点击查询时，传入筛选对象，此时还没有区域id     后台  服务常调用的方法
      let rD = { areaNames: [...this.areaNames] }
      this.$api.changePlace(rD).then(res =>{
        if (res.data.status === 0) {
          let id = JSON.parse(res.data.data)
          newForm.areaId = id[id.length-1]
          console.log(newForm.areaId)
          //以上都为拿到筛选区域的区域id和筛选条件的对象的其它属性
          this.getData(newForm)
          this.filterForm.pageNumber ? delete this.filterForm.pageNumber: ''
        } else {
          this._status(res.data)
        }
      })
    },
  },
}